import {hasClass, addClass} from '../common/Utils.js';

export default class IdVerify {
    constructor(_config){
        if ( location.pathname != "/" && location.pathname != '/sample/testIdVerify.html' ) return;
        if ( hasClass(document.body, 'mobile') ) return;
        if ( !_config.useIdVerify ) return;
        if ( !_config.isLogin ) return;
        this.setting();
    }

    setting(){
        let msg = this.checkMsg()
        if ( !msg ) return;
        document.body.appendChild( this.template(msg) );
        this.addEvents();
    }

    checkMsg(){
        let msg = '';
        userData.accountState.map( it =>{
            if(it.case==7 || it.case==8) msg = it.msg;
        });
        return msg;
    }

    template(_msg){
        this.el = document.createElement('div');
        this.el.id = "id-verify";
        addClass(this.el, "id-verify");
        this.el.innerHTML = `
        <div class="id-verify__wrapper" data-testid="id-verify">
            ${_msg}<button class="id-verify__close"><span class="blind">X</span></button>
        </div>`;
        return this.el;
    }

    addEvents(){
        document.querySelector(".id-verify__close").addEventListener('click', e =>{
            this.el.parentNode.removeChild(this.el);
        });
    }

} // end of class